<template>
  <div class="colorfulLife">
    <h3>缤纷生活</h3>
    <span>公司为员工提供全面的、富有竞争力的薪资鼓励待遇。</span>
    <!-- <el-card class="box-card" :body-style="{ padding: '0px' }">
      <div>
        <img
          :src="require('../../assets/colorlife/icon_holiday_care.png')"
          alt
          style="width:6.1875rem;height:5.3125rem;margin-top: 3.125rem;margin-bottom:2rem;"
        />
        <p
          style="font-size:1.5rem;line-height:2.25rem;font-weight:600;color:#1A1A1A;margin-bottom:1.625rem;"
        >
          假期关怀
        </p>
        <p
          style="font-size:1.5rem;line-height:2.25rem;font-weight:400;color:#777777;margin-bottom: 3rem;"
        >
          公司为员工提供多种全薪假期，<br />包括法定节假日、女生节假期（3.8）、<br />亲子陪伴假（6.1）、春节探亲假、带薪事假、产检假、<br />产假、哺乳假、陪产假、计划生育假、丧假及路程假等。<br />员工从试用期起即可享受带薪年假，<br />入职前两年每年享受带薪年假6天，入职第三年带薪年假<br />增加至10天，入职3周年后每年带薪年假为15天。
        </p>
      </div>
    </el-card> -->
    <div class="actives">
      <el-row :gutter="4">
        <el-col
          v-for="(item, index) in actives"
          :key="index"
          :span="12"
          style="margin-top: .875rem;"
        >
          <el-card class="active" :body-style="{ padding: '0px' }">
            <div style="min-height:16rem ;">
              <img
                :src="item.icon"
                alt
                style="width:6.1875rem;height:5.3125rem; margin-top: 3.125rem;margin-bottom: 2rem;"
              />
              <span
                style="font-weight: 600;color: #1A1A1A;text-align: center;display: block;margin-bottom: 1.625rem;"
                >{{ item.title }}</span
              >
              <!-- <div
                v-html="item.desc"
                style="font-size:1.5rem;line-height:2.25rem;color: #777777;margin-bottom: 2.5rem;"
              ></div> -->
            </div>
          </el-card>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<style scoped>
h3 {
  padding-top: 3.625rem;
  padding-bottom: 2.1875rem;
  color: #1a1a1a;
  font-size: 2.25rem;
  line-height: 3.75rem;
}
span {
  font-size: 1.5rem;
  line-height: 2.25rem;
  color: #777777;
}
.box-card {
  width: 90%;
  display: inline-block;
  margin-top: 3.75rem;
}
.actives {
  width: 90%;
  height: fit-content;
  display: inline-block;
  margin-bottom: 50px;
  background-color: #fff;
}
.el-card {
  border-radius: 0.625rem;
}
</style>
<script>
export default {
  data() {
    return {
      msg: "缤纷生活",
      banners: [{ url: require("../../assets/welfare/header.png") }],
      actives: [
                {
          icon: require("../../assets/colorlife/icon_holiday_care.png"),
          title: "假期关怀",
          desc:
            ""
        },
        {
          icon: require("../../assets/colorlife/icon_01.png"),
          title: "开工红包",
          desc:
            "在春节假期后复工的第一天，<br/>公司给员工派发“开工红包”，<br/>祝福员工在新年伊始<br/>就得到佳绩，开工大吉。"
        },
        {
          icon: require("../../assets/colorlife/icon_03.png"),
          title: "月度团建",
          desc:
            "公司为每一位员工提供了<br/>月度部门活动经费，<br/>更好地促进同事之间<br/>的沟通和交流。"
        },
        {
          icon: require("../../assets/colorlife/icon_02.png"),
          title: "节庆活动",
          desc: "举办多样化节日庆祝活动，<br/>与员工一起欢度佳节。"
        },
        {
          icon: require("../../assets/colorlife/icon_04.png"),
          title: "月度下午茶",
          desc:
            "公司每月为员工提供下午茶<br/>福利，工作之余放松心情，<br/>享受闲适时光。"
        },
        // {
        //   icon: require("../../assets/colorlife/icon_05.png"),
        //   title: "年度旅游",
        //   desc: "公司每年组织一次出游活动，<br/>鼓励员工轻松出发、<br/>玩得尽兴。"
        // },
        // {
        //   icon: require("../../assets/colorlife/icon_06.png"),
        //   title: "年会",
        //   desc:
        //     "公司每年举办一场“家庭盛宴”<br/>，吃喝玩乐，心跳抽奖，<br/>士气激昂，展望未来。"
        // },
        {
          icon: require("../../assets/colorlife/icon_07.png"),
          title: "企业滴滴",
          desc:
            "为解决员工的加班出行问题，<br/>公司引进企业滴滴的便捷服务<br/>让员工用心上班、平安到家。"
        },
        {
          icon: require("../../assets/colorlife/icon_08.png"),
          title: "暖心礼金",
          desc:
            "生日礼金、结婚礼金、<br/>生育礼金、 节日礼金、<br/>住院慰问、丧事帛金等。"
        }
      ]
    };
  }
};
</script>



// WEBPACK FOOTER //
// src/components/mobile/ColorfulLife.vue